import { useState, useCallback } from "react";

const useFetch = (url) => {
  const [response, setResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [abortController, setAbortController] = useState(null);

  const doFetch = useCallback(
    (options = {}, responseHandler = null) => {
      const fetchData = async () => {
        setIsLoading(true);

        try {
          const abortController = new AbortController();
          const signal = abortController.signal;
          setAbortController(abortController);

          const res = await fetch(url, { ...options, signal });

          if (responseHandler) {
            responseHandler(res);
          } else {
            switch (res.status) {
              case 200:
                const json = await res.json();
                setResponse(json);
                break;
              case 401:
                window.location.href = '/login';
                break;
              case 404:
                window.location.href = '/not-found';
                break;
              case 500:
                (process.env?.NODE_ENV !== "development") && (window.location.href = '/simulateur-erreur');
                break;
              default:
                window.location.href = '/not-found';
                break;
            }
          }
        } catch (error) {
          setError(error);
        }

        setIsLoading(false);
      };

      url && fetchData();
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [url]
  );

  return [doFetch, response, isLoading, error, abortController];
};

export default useFetch;
